import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

const REFRESH_MILLISECONDS = 60 * 1000

// A crew turns due and urgent with time alone; a timer in the page keeps working when the cable or the job queue does not.
export class BreaksRefreshController extends Controller {
  connect() {
    this.timer = setInterval(() => Turbo.visit(window.location.href, { action: "replace" }), REFRESH_MILLISECONDS)
  }

  disconnect() {
    clearInterval(this.timer)
  }
}
